import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-edit-table-columns',
  templateUrl: './edit-table-columns.component.html',
  styleUrls: ['./edit-table-columns.component.scss'],
  standalone: false
})
export class EditTableColumnsComponent implements OnInit {
  public dataType;
  public columns;
  public displayedColumns;
  public checked = {};

  constructor(protected ref: NbDialogRef<EditTableColumnsComponent>) {}

  public ngOnInit() {
    this.columns.forEach((column) => {
      if (this.displayedColumns.includes(column)) {
        this.checked[column] = true;
      } else {
        this.checked[column] = false;
      }
    });
  }

  public toggle(column: string, checked: boolean) {
    this.checked[column] = checked;
  }

  public save() {
    Object.keys(this.checked).forEach((column) => {
      if (!this.displayedColumns.includes(column)) {
        if (this.checked[column]) {
          this.displayedColumns.splice(1, 0, column);
        }
      } else {
        if (!this.checked[column]) {
          this.displayedColumns = this.displayedColumns.filter((item) => item !== column);
        }
      }
    });
    localStorage.setItem(this.dataType + '_columns', JSON.stringify(this.displayedColumns));
    this.ref.close(true);
  }

  public cancel() {
    this.ref.close();
  }
}
